import { React } from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'

import './Mentions.scss'

import { useDocumentTitle, useDocumentConfig } from 'hooks/useDocument'

const Mentions = () => {
    useDocumentTitle(`Mentions légales`)
    useDocumentConfig(`blue`, true)

    return (
        <motion.main
            className="mentions"
            initial={{ opacity: 0, transition: { duration: 0.3 } }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0, transition: { duration: 0.3 } }}
        >
            <h1>Mentions légales</h1>

            <h2>Identification</h2>
            <p className="light">
                BIG et Nouf est une <abbr title="Société À Responsabilités Limitées">SARL</abbr> au capital social de 2&nbsp;000&nbsp;&euro;.<br />
                SIRET&nbsp;: 97842850600023<br />
                TVA intercommunautaire&nbsp;: FR55978428506<br />
                Marque déposée <abbr title="Institut National de la Propriété Industrielle">INPI</abbr>&nbsp;: 4983611 
                
            </p>

            <address>
                Siège social&nbsp;:<br />
                BIG et Nouf<br />
                17 Boulevard de Strasbourg<br />
                62000 Arras<br />
                France
            </address>

            <p className="light">
                <Link className="link" to="mailto:contact@bigetnouf.fr">contact@bigetnouf.fr</Link><br />
                <Link className="link" to="tel:+33695179184">06&nbsp;95&nbsp;17&nbsp;91&nbsp;84</Link>
            </p>


            <h2>Responsables de la publication / Gérants</h2>
            <ul className="list no-prefix">
                <li>Marion Dournel</li>
                <li>François Beaumont</li>
            </ul>


            <h2>Hébergement</h2>

            <address>
                o2switch<br />
                Chemin des Pardiaux<br />
                63000 Clermont-Ferrand<br />
                France
            </address>

            <p className="light">
                <Link className="link" to="tel:+33444446040">04&nbsp;44&nbsp;44&nbsp;60&nbsp;40</Link>
            </p>

            <h2>Politique de confidentialité</h2>

            <h3>Données personnelles collectées</h3>
            <p className="light">
                Ce site ne collecte aucune donnée personnelle automatiquement. Les seules données que nous pouvons recevoir sont celles que vous nous transmettez volontairement par email.
            </p>

            <h3>Utilisation des données</h3>
            <p className="light">
                Si vous nous contactez par email, nous utilisons uniquement vos coordonnées pour répondre à votre demande. Ces données ne sont jamais transmises à des tiers sans votre consentement explicite.
            </p>

            <h3>Conservation des données</h3>
            <p className="light">
                Les emails reçus sont conservés pendant la durée nécessaire au traitement de votre demande, puis archivés ou supprimés selon leur nature.
            </p>

            <h3>Vos droits</h3>
            <p className="light">
                Conformément au <abbr title="Règlement Général sur la Protection des Données">RGPD</abbr>, vous disposez des droits suivants&nbsp;:
            </p>
            <ul className="list no-prefix">
                <li>Droit d'accès à vos données personnelles</li>
                <li>Droit de rectification des données inexactes</li>
                <li>Droit d'effacement de vos données</li>
                <li>Droit d'opposition au traitement</li>
                <li>Droit à la portabilité de vos données</li>
            </ul>
            <p className="light">
                Pour exercer ces droits, contactez-nous par email à <Link className="link" to="mailto:contact@bigetnouf.fr">contact@bigetnouf.fr</Link>.
            </p>

            <h3>Cookies</h3>
            <p className="light">
                Ce site utilise les cookies suivants&nbsp;:
            </p>
            <ul className="list no-prefix">
                <li><strong>Cookies techniques</strong>&nbsp;: nécessaires au fonctionnement du site</li>
                <li><strong>Google Analytics</strong>&nbsp;: pour analyser l'audience du site de manière anonyme</li>
            </ul>
            <p className="light">
                Les données collectées par Google Analytics sont anonymisées et utilisées uniquement à des fins statistiques pour améliorer l'expérience utilisateur. Vous pouvez désactiver ces cookies en configurant votre navigateur.
            </p>

            <h3>Sécurité</h3>
            <p className="light">
                Nous mettons en œuvre toutes les mesures techniques et organisationnelles appropriées pour protéger vos données contre la perte, l'utilisation abusive ou l'accès non autorisé.
            </p>

            <h3>Modifications</h3>
            <p className="light">
                Cette politique de confidentialité peut être modifiée à tout moment. La version en vigueur est celle publiée sur ce site.
            </p>

            <h3>Contact</h3>
            <p className="light">
                Pour toute question concernant cette politique de confidentialité, vous pouvez nous contacter à&nbsp;:
            </p>
            <address>
                BIG et Nouf<br />
                17 Boulevard de Strasbourg<br />
                62000 Arras<br />
                France
            </address>
            <p className="light">
                <Link className="link" to="mailto:contact@bigetnouf.fr">contact@bigetnouf.fr</Link>
            </p>
        </motion.main>
    )
}

export default Mentions